import React from 'react';
import { string, shape, arrayOf } from 'prop-types';
import { Base } from '@fiverr-private/modal/src';
import Image from '../Image';
import ModalBody from './ModalBody';

import './style.scss';

const ModalName = 'logged-out-homepage-video-modal';

const VideoModal = ({imgSrc, pictureData = [], videoUrl, onOpen}) => (
    <div className="video-modal">
        <Base name={ModalName} onOpen={onOpen} trigger={({ open }) => (
            <div className="picture-wrapper" onClick={open}>
                <picture>
                    {
                        pictureData.map((image, index) => (
                            <source key={index} media={image.media} srcSet={image.srcSet}/>
                        ))
                    }
                    <Image src={imgSrc} alt="logged_out_homepage.video_modal.image"/>
                </picture>
            </div>
        )} header=" ">
            {() => <ModalBody videoUrl={videoUrl}/>}
        </Base>
    </div>
);

VideoModal.propTypes = {
    imgSrc: string,
    pictureData: arrayOf(
        shape({
            srcSet: string,
            media: string
        })
    ),
    videoUrl: string
};

export default VideoModal;
